export default `Lobby
-=80
K=0
B=0
D=0
P=0
S=0
F=0

xxxxxxxxxxxxxxx
xxxxxxxxxxxxxxx
xxxxxxxxxxxxxxx
xxx---------xxx
xxx-x1x x3x-xxx
xxx-       -xxx
xxx-x xGx x-xxx
xxx-       -xxx
xxx-x4x x2x-xxx
xxx---------xxx
xxxxxxxxxxxxxxx
xxxxxxxxxxxxxxx
xxxxxxxxxxxxxxx`
